import React, { useEffect, useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import Customform from "../../../ui/custom-form";
import CustomInput from "../../../ui/custom-input";
import { useDispatch, useSelector } from "react-redux";
import { SetPopupReducerData } from "../../../store/reducer/PopupReducer";
import CustomButton from "../../../ui/custom-button";
import { PulseLoader } from "react-spinners";
import {
  createDeviceControllers,
  fetchCameragrouplistingApi,
  getOneDeviceControllers,
  updateDeviceControllers,
} from "../../../api/api";
import { toast } from "react-toastify";

function AddController() {
  const dispatch = useDispatch();
  const [cameraGroups, setCameraGroups] = useState([]);
  //console.log("cameraGroups", cameraGroups);
  const [loading, setLoading] = useState(false);
  const { user_id, organization_id } = useSelector(
    (state) => state?.authUser?.data?.data
  );
  const { data } = useSelector((state) => state?.PopupReducer?.modal || {});

  const [inputData, setInputData] = useState({
    device_name: "",
    ip_address: "",
    camera_group_id: "",
    alert: "",
    action: "",
    device_port: "",
  });

  const fetchCameraGroup = async () => {
    try {
      const data = await fetchCameragrouplistingApi(
        "",
        user_id,
        organization_id
      );
      if (data?.data?.status === true) {
        setCameraGroups(data?.data?.data);
      }
    } catch (error) {
      //console.log("error", error);
    }
  };

  useEffect(() => {
    fetchCameraGroup();
    if (data) {
      fetchDetail();
    }
  }, []);

  const fetchDetail = async () => {
    try {
      const details = await getOneDeviceControllers(
        data,
        user_id,
        organization_id
      );
      console.log("details", details);
      if (details?.data?.data) {
        const detailsData = details?.data?.data;
        setInputData({
          device_name: detailsData?.device_name,
          ip_address: detailsData?.ip_address,
          camera_group_id: detailsData?.camera_group_id,
          alert: detailsData?.alert,
          action: detailsData?.action,
          device_port: detailsData?.device_port,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleClose = () => {
    dispatch(
      SetPopupReducerData({
        modalType: "",
        showModal: false,
      })
    );
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (data) {
      const payload = {
        ...inputData,
        user_id,
        organization_id,
        device_id: data,
      };

      //console.log("Submitting payload:", payload);

      try {
        const data = await updateDeviceControllers(payload);
        if (data) {
          toast("Controller created successfully");
          handleClose();
        }
      } catch (error) {
        console.error("Error submitting Controller:", error);
        // toast.error("Failed to create event.");
      } finally {
        setLoading(false);
      }
    } else {
      const payload = {
        ...inputData,
        user_id,
        organization_id,
      };

      //console.log("Submitting payload:", payload);

      try {
        const data = await createDeviceControllers(payload);
        if (data) {
          toast("Controller created successfully");
          handleClose();
        }
      } catch (error) {
        console.error("Error submitting Controller:", error);
        // toast.error("Failed to create event.");
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="rightModal taskModal">
      <div className="modal-header p-3">
        <h4 className="m-0">{data ? "Update" : "Add"} Controller</h4>
        <button className="btnClose ms-auto" onClick={handleClose}>
          <IoCloseOutline />
        </button>
      </div>

      <div className="p-4">
        <Customform onSubmit={handleSubmit}>
          <div className="col-12 mb-3">
            <label className="form-label">Device Controller Name</label>
            <CustomInput
              name="device_name"
              placeholder="Enter Device Name"
              value={inputData.device_name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-12 mb-3">
            <label className="form-label">IP address</label>
            <CustomInput
              name="ip_address"
              placeholder="Enter IP Address"
              value={inputData.ip_address}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-12 mb-3">
            <label className="form-label">Port</label>
            <CustomInput
              name="device_port"
              placeholder="Enter Port"
              value={inputData.device_port}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-12 mb-3">
            <label className="form-label">Alert</label>
            <CustomInput
              name="alert"
              placeholder="Enter Alert"
              value={inputData.alert}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-12 mb-3">
            <label className="form-label">Action</label>
            <CustomInput
              name="action"
              placeholder="Enter Action"
              value={inputData.action}
              onChange={handleChange}
            />
          </div>

          <div className="col-12 mb-3">
            <label className="form-label">Camera Group</label>
            <select
              name="camera_group_id"
              className="form-select"
              value={inputData.camera_group_id}
              onChange={handleChange}
            >
              <option value="">Select</option>
              {cameraGroups &&
                cameraGroups?.map((ele) => (
                  <option value={ele?._id}>{ele?.camera_grp_name}</option>
                ))}
            </select>
          </div>

          <div className="bottomBtn d-flex justify-content-between mt-4">
            <button
              className="btn btn-outline-secondary px-4"
              type="button"
              onClick={handleClose}
            >
              Cancel
            </button>

            {loading ? (
              <CustomButton type="submit" className="btnSubmit px-4 py-2">
                <PulseLoader color="#fff" size={8} />
              </CustomButton>
            ) : (
              <button className="btnSubmit px-4 py-2" type="submit">
                {data ? "Update" : "Submit"}
              </button>
            )}
          </div>
        </Customform>
      </div>
    </div>
  );
}

export default AddController;
